import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Heartbeat } from "@/components/site/Heartbeat";

const FAQS = [
  {
    q: "Quali corsi di formazione offrite?",
    a: "Offriamo un'ampia gamma di corsi di formazione e aggiornamento in materia di salute e sicurezza sul lavoro, antincendio e primo soccorso, BLSD, attrezzature di lavoro, cantieri e lavori in quota, rischi specifici e sicurezza alimentare. Proponiamo inoltre percorsi formativi dedicati alle diverse figure della sicurezza aziendale.",
  },
  {
    q: "A chi sono rivolti i vostri corsi?",
    a: "I nostri corsi sono rivolti a lavoratori, aziende, datori di lavoro e alle principali figure coinvolte nella gestione della salute e sicurezza sul lavoro. I percorsi vengono individuati in base al ruolo, all'attività svolta e alle specifiche esigenze formative.",
  },
  {
    q: "Come posso iscrivermi a un corso?",
    a: (
      <>
        È possibile effettuare l'iscrizione attraverso l'apposito{" "}
        <a href="#contatti" className="text-brand-red underline">
          modulo presente sul nostro sito
        </a>
        .
      </>
    ),
  },
  {
    q: "Come posso conoscere le prossime date disponibili?",
    a: "Le date dei corsi disponibili sono indicate sul nostro sito e vengono aggiornate periodicamente. Per conoscere le prossime sessioni o ricevere informazioni su una specifica formazione, è possibile contattarci direttamente.",
  },
  {
    q: "Al termine del corso viene rilasciato un attestato?",
    a: "Al termine del percorso formativo, e a seguito del completamento dei requisiti previsti per lo specifico corso, viene rilasciato il relativo attestato di formazione secondo le normative vigenti.",
  },
  {
    q: "È possibile organizzare un corso direttamente presso la propria azienda?",
    a: "Sì, è possibile organizzare percorsi formativi direttamente presso la sede dell'azienda, concordando modalità, date e numero di partecipanti in base alle specifiche esigenze. Questa soluzione consente di formare più lavoratori in modo pratico e flessibile, riducendo gli spostamenti e adattando la formazione alle necessità dell'attività.",
  },
  {
    q: "Quali sono i costi dei vostri corsi?",
    a: "I costi variano in base alla tipologia di servizio richiesto, alla durata e alle specifiche esigenze del cliente. Per ricevere maggiori informazioni e un preventivo personalizzato, è possibile contattarci direttamente.",
  },
];

export const Faq = () => {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4 min-w-0">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-red mb-5">
            Domande frequenti
          </div>
          <h2 className="font-heading font-bold text-4xl md:text-5xl tracking-tighter text-brand-black leading-none">
            Tutto quello che vuoi sapere.
          </h2>
          <div className="mt-8">
            <Heartbeat height={56} />
          </div>
        </div>

        <div className="lg:col-span-7 lg:col-start-6">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-border"
                >
                  <AccordionTrigger className="text-left font-heading font-bold text-lg md:text-xl text-brand-black hover:text-brand-red hover:no-underline py-6">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-brand-ink text-base leading-relaxed pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
